/* eslint-disable react/jsx-pascal-case */
// src/App.tsx
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './Layouts/Layout';
import Home from './Pages/Home/Home';
import Intern from './Pages/Home/Intern';
import Login from './Pages/Login/Login';
import Register from './Pages/Login/Register';
import ResetPassword from './Pages/Login/ResetPassword';
import Admin from './Pages/Admin/Admin';
import UserAdmin from './Pages/Admin/UserAdmin/UserAdmin';

import Team2 from './Pages/Admin/Forms/CreateTransportArrival';
import Meeting from "./Pages/Admin/Forms/Create_Meeting";
import Practice from "./Pages/Admin/Practice/Create_Practice";
import Transport from "./Pages/Admin/Forms/TransportSide";
import FormTransportArrivalCreate from "./Pages/Admin/Forms/CreateTransportArrival";
import FormTransportDepartureCreate from "./Pages/Admin/Forms/CreateTransportDeparture";
import FormTransportLokalCreate from "./Pages/Admin/Forms/CreateTransportLokal";
import Transport_ArrivalListe from "./Pages/Admin/Forms/Transport_ArrivalListe";
import MediaDashboard from './Pages/Media/MediaDashboard';
import TeamDashboard from './Pages/Admin/Team/TeamDashboard';
import ClubDashboard from './Pages/Admin/Club/ClubDashboard';
import ChampDashboard from './Pages/Admin/Champ/ChampDashboard';
import TransportDashboard from './Pages/Admin/Transport/TransportDashboard';
import EventPage from './Pages/Tilmeld/EventPage';
import Persons from './Pages/Admin/ID/Persons';
import IDCardDesignerPage from './Pages/Admin/ID/IDCardDesignerPage';
import AdminEvent from './Pages/Admin/Event/AdminEvent';
import EventMenuPage from './Pages/Admin/Event/EventMenuPage';
import DrinksMenuPage from './Pages/Admin/Drinks/DrinksMenuPage';
import ZonesPage from './Pages/Admin/Zones/ZonesPage';
import UserDashboard from './Pages/Profil/UserDashboard';
import PrivateRoute from './components/PrivateRoute';
import CreateQRCode from "./Pages/Plugins/Parking/CreateQRCode";
import QRCodeList from "./Pages/Plugins/Parking/QRCodeList";
import QRScanner from "./Pages/Plugins/Parking/QRScanner";
import RoleSelect from "./Pages/Login/RoleSelect";
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import Unauthorized from "./Pages/Unauthorized/Unauthorized";
import EventListPage from "./Pages/Tilmeld/EventListPage";
import { LanguageProvider } from "./context/LanguageContext";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import VisaPage from './Pages/Admin/Visa/VisaPage';     
import VisaPageFront from './Pages/Visa/VisaPageFront';
import ShiftsPage from './Pages/Admin/Shifts/ShiftsPage';
import EventFilesAdminPage from "./Pages/Admin/Filesystem/EventFilesAdminPage";
import EventFilesViewPage from "./Pages/Admin/Filesystem/EventFilesViewPage";
import EventPersonOversigt from "./Pages/EventPersonOversigt/EventPersonOversigt";
import TicketDashBoard from "./Pages/Admin/Ticket/TicketsBoardPage"
import TransportBookingPage from "./Pages/Transport/TransportBookingPage";
import ExperienceBookingPage from "./Pages/Experience/ExperienceBookingPage";
import AdminMessagePage from "./Pages/Admin/GruppeBeskeder/AdminMessagePage";
import FriviligePage from "./Pages/Admin/FriviligeListe/FriviligePage";
import TransportAdminPageSettings from "./Pages/Admin/Transport/Settings/TransportSetupPage";
import TransportAdminPageDaily from "./Pages/Admin/Transport/Daily/TransportAdminPage";
import ExperienceAdminPage from "./Pages/Admin/Experience/ExperienceAdminPage";
import TransportRequestOverview from "./Pages/Transport/TransportRequestOverview";
import TeamPerson from "./Pages/Team/TeamPerson";
import TransportArrivalRequestPage from "./Pages/Transport/TransportArrivalRequestPage";
import TransportDepartureRequestPage from "./Pages/Transport/TransportDepartureRequestPage";
import MediaAdminPage from "./Pages/Admin/Media/MediaAdminPage";
import AdminTransportBookings from "./Pages/Admin/Transport/StartEnd/AdminTransportBookings";
import TransportRouteAdminPage from "./Pages/TransportRoute/TransportRouteAdminPage";
import TransportRouteDashboard from "./Pages/Admin/Transport/TransportRoute";
import AllAvailableShiftListPublic from "./Pages/Tilmeld/AllAvailableShiftListPublic"

import TransportLocalRequestPage from "./Pages/Transport/TransportLocalRequestPage";
// Drinks – Bar
import FormDrinkOrder from "./Pages/Drinks/FormDrinkOrder";

// Drinks – Admin
import AdminDrinkFunctionAllowance from "./Pages/Drinks/AdminDrinkFunctionAllowance";
import AdminDrinkPersonAllowance from "./Pages/Drinks/AdminDrinkPersonAllowance";
import AdminDrinkAllowance from "./Pages/Drinks/AdminDrinkAllowance";
//import AdminPersonExtraDrinks from "./Pages/Drinks/FormDrinkOrder";
import AdminDrinkOverview from "./Pages/Drinks/AdminDrinkOverview";
import AdminDrinkTicketCollections from "./Pages/Drinks/AdminDrinkTicketCollections";
import DrinkTicketOrder from "./Pages/Drinks/DrinkTicketOrder";
import AdminDrinkTicketPrint from "./Pages/Drinks/AdminDrinkTicketPrint";
import AdminDrinkAssignedPersons from "./Pages/Drinks/AdminDrinkAssignedPersons";
import EventBarsPage from "./Pages/Drinks/EventBars";

import Form_Practice from "./Pages/Admin/Practice/Create_Practice";
import TransportMyBookings from "./Pages/Transport/TransportMyBookings"
import MeeetingAdminPage from "./Pages/Admin/Meeting/MeetingAdminPage";
import WhatsAppAdmin from "./Pages/Admin/WhatsApp/WhatsAppAdmin";

import TransportRouteBookingPage from "./Pages/TransportRoute/TransportRouteBookingPage";
import TransportRouteBookingsAdminPage from "./Pages/TransportRoute/TransportRouteBookingsAdminPage";
import TransportVIP from "./Pages/Admin/Parking/ParkingPerson";
import ParkingValidationPage from "./Pages/Admin/Parking/ParkingValidationPage";
import ParkingQrValidationPage from "./Pages/Admin/Parking/ParkingQrValidationPage ";
import ParkingQrPassPage from "./Pages/Admin/Parking/ParkingQrPassPage";

import EventOverviewFeatureAccessAdminPage from "./Pages/Admin/EPOS/EventOverviewFeatureAccessAdminPage"
import HotelAdminPage from "./Pages/Admin/Hotels/HotelAdminPage";
import HotelBookingPage from "./Pages/Hotels/HotelBookingPage";
import HotelBookingAdminPage from "./Pages/Admin/Hotels/HotelBookingAdminPage";

import HotelMenuPage from './Pages/Admin/Hotels/HotelMenuPage';
import HotelPaymentSuccessPage from "./Pages/Admin/Hotels/HotelPaymentSuccessPage";
import HotelPaymentCancelPage from "./Pages/Admin/Hotels/HotelPaymentCancelPage";
import HotelRoomingListPage from "./Pages/Hotels/HotelRoomingListPage";

import VolunteerGroupsPage from "./Pages/Admin/VolunteerGroup/VolunteerGroups";
import VolunteerGroupsDashboard from "./Pages/VolunteerGroups/VolunteerGroupsDashBoard";

const App: React.FC = () => {

    // Track logged-in user globally
    const [currentUser, setCurrentUser] = useState({
        token: sessionStorage.getItem("authToken"),
        userId: sessionStorage.getItem("userId"),
        email: sessionStorage.getItem("email"),
        firstName: sessionStorage.getItem("firstName"),
        lastName: sessionStorage.getItem("lastName"),
        personId: sessionStorage.getItem("personId"),
    });

    useEffect(() => {
        const handleAuthChange = () => {
            setCurrentUser({
                token: sessionStorage.getItem("authToken"),
                userId: sessionStorage.getItem("userId"),
                email: sessionStorage.getItem("email"),
                firstName: sessionStorage.getItem("firstName"),
                lastName: sessionStorage.getItem("lastName"),
                personId: sessionStorage.getItem("personId"),
            });
        };

        window.addEventListener("auth-changed", handleAuthChange);
        return () => window.removeEventListener("auth-changed", handleAuthChange);
    }, []);

    return (
        <MantineProvider>
            <Notifications />
            <LanguageProvider>
                <Router basename="/">
                    <Routes>

                        {/* =========================
                        🌍 PUBLIC / GLOBAL
                        ========================= */}
                        <Route path="unauthorized" element={<Unauthorized />} />
                        <Route path="/epos/:personId/:eventId" element={<EventPersonOversigt />} />

                        {/* =========================
                            🏗️ LAYOUT WRAPPER
                            ========================= */}
                        <Route path="/" element={<Layout />}>

                            {/* 🏠 HOME / BASIC PAGES */}
                            <Route path="/" element={<Home />} />
                            <Route path="/intern" element={<Intern />} />
                            <Route path="/team" element={<EventListPage entry="team" title="Team events" />} />
                            <Route path="/media" element={<EventListPage entry="media" title="Media events" />} />
                            <Route path="/volunteer-groups" element={<EventListPage entry="volunteer" title="Frivillig grupper" />} />
                            <Route
                                path="/VolunteerGroupsDashboard/:eventId"
                                element={<VolunteerGroupsDashboard />}
                            />
                            <Route path="/intern" element={<EventListPage entry="intern" title="Interne events" />} />

                            {/* 🔐 AUTH */}
                            <Route path="login" element={<Login />} />
                            <Route path="register" element={<Register />} />
                            <Route path="/reset-password" element={<ResetPassword />} />

                            {/* 🚗 PARKING / QR */}
                            <Route path="/parkering/qr-scanner" element={<QRScanner />} />
                            <Route path="parkering/create-qr" element={<PrivateRoute />}>
                                <Route index element={<CreateQRCode />} />
                            </Route>

                            <Route path="parkering/list" element={<PrivateRoute />}>
                                <Route index element={<QRCodeList />} />
                            </Route>


                            {/* 👤 ROLE SELECT */}
                            <Route path="role-select" element={<PrivateRoute />}>
                                <Route index element={<RoleSelect />} />
                            </Route>

                            {/* 📅 SHIFTS */}
                            <Route path="shifts" element={<PrivateRoute />}>
                                <Route index element={<ShiftsPage />} />
                            </Route>

                            {/* 🪪 USER DASHBOARD */}
                            <Route path="UserDashboard" element={<PrivateRoute />}>
                                <Route index element={<UserDashboard />} />
                            </Route>

                            {/* 🎟️ EVENT PAGES */}
                            <Route path="EventPage/:eventId" element={<PrivateRoute />}>
                                <Route index element={<EventPage />} />
                            </Route>

                            <Route path="EventPage/:eventId/Function/:functionsId" element={<PrivateRoute />}>
                                <Route index element={<EventPage />} />
                            </Route>

                            <Route path="EventPage/:eventId/:functionsId" element={<PrivateRoute />}>
                                <Route index element={<EventPage />} />
                            </Route>

                            <Route path="/events/:eventId/shifts/public" element={<AllAvailableShiftListPublic language="da" />}
                            />

                            {/* =========================
                            👥 TEAM AREA (PROTECTED)
                            ========================= */}
                            <Route path="/TeamDashboard" element={<PrivateRoute allowedRoles={["Team"]} />}>

                                <Route index element={<EventListPage entry="team" title="Team events" />} />
                             
                                <Route path="Visa/:eventId/:userId" element={<VisaPageFront />} />

                                <Route path="Practice/:eventId/:userId" element={<Practice />} />

                                <Route path="transport/booking/:eventId/:userId" element={<TransportRequestOverview />} />

                                <Route path="Accreditations/:eventId/:userId" element={<TeamPerson />} />

                            </Route>

                            <Route path="TeamDashboard/:eventId/" element={<TeamDashboard />} />

                            {/* 🎥 MEDIA */}
                            <Route path="MediaDashboard/:eventId/" element={<MediaDashboard />} />
                            {/*<Route path="/MediaDashboard/:eventId" element={<PrivateRoute allowedRoles={["Media"]} />}>*/}
                            {/*    <Route index element={<MediaDashboard />} />*/}
                            {/*</Route>*/}

                            {/* 🏟️ CLUB / TEAM2 */}
                            <Route path="Club" element={<PrivateRoute allowedRoles={["Club"]} />}>
                                <Route index element={<ClubDashboard />} />
                            </Route>

                            <Route path="Team2" element={<PrivateRoute />}>
                                <Route index element={<Team2 />} />
                            </Route>

                            {/* =========================
                            🚐 TRANSPORT (PROTECTED USER AREA)
                            ========================= */}
                            <Route path="/Transport" element={<PrivateRoute />}>
                                <Route index element={<Transport />} />
                                <Route path="arrival/create" element={<FormTransportArrivalCreate />} />
                                <Route path="departure/create" element={<FormTransportDepartureCreate />} />
                                <Route path="local/create" element={<FormTransportLokalCreate />} />
                                <Route path="arrival/list" element={<Transport_ArrivalListe />} />
                            </Route>

                            {/* 🤝 MEETING / PRACTICE */}
                            <Route path="Meeting" element={<Meeting />} />
                            <Route path="/meeting/:eventId/:userId?" element={<Meeting />} />

                            <Route path="Practice" element={<Practice />} />
                            <Route path="/practice/:eventId/:userId?" element={<Practice />} />

                            {/* 📦 EVENT / ADMIN TOOLS */}
                            <Route path="Event/Event" element={<PrivateRoute />}>
                                <Route index element={<AdminEvent />} />
                            </Route>

                            <Route path="EventMenu" element={<PrivateRoute />}>
                                <Route index element={<EventMenuPage />} />
                            </Route>

                            <Route path="DrinksMenu" element={<PrivateRoute />}>
                                <Route index element={<DrinksMenuPage />} />
                            </Route>

                            <Route path="event/zones" element={<PrivateRoute />}>
                                <Route index element={<ZonesPage />} />
                            </Route>

                            {/* 🎫 TICKET / ID */}
                            <Route path="Ticket" element={<PrivateRoute allowedRoles={["Admin", "Champ"]} />}>
                                <Route index element={<TicketDashBoard />} />                             
                            </Route>
                            <Route path="Champ" element={<PrivateRoute allowedRoles={["Admin", "Champ"]} />}>
                                <Route index element={<ChampDashboard />} />
                            </Route>

                            <Route path="id" element={<PrivateRoute />}>
                                <Route index element={<Persons />} />
                            </Route>

                            {/* 🏨 HOTEL (USER SIDE) */}
                            <Route path="/TeamDashboard/hotel/booking/:eventId/:userId" element={<HotelBookingPage />} />
                            <Route path="/hotel/booking/:eventId/:userId/:bookingId/rooms" element={<HotelRoomingListPage />} />

                            {/* 🆔 ID / MESSAGES / USERS */}
                            <Route path="iddesigner" element={<PrivateRoute />}>
                                <Route index element={<IDCardDesignerPage />} />
                            </Route>

                            <Route path="gruppebeskeder" element={<PrivateRoute />}>
                                <Route index element={<AdminMessagePage />} />
                            </Route>

                            <Route path="friviligeliste" element={<PrivateRoute />}>
                                <Route index element={<FriviligePage />} />
                            </Route>

                            <Route path="useradmin" element={<PrivateRoute allowedRoles={["Admin"]} />}>
                                <Route index element={<UserAdmin />} />
                            </Route>

                            {/* 🍹 DRINKS (USER SIDE) */}
                            <Route path="/form-drink-order/:eventId/:id" element={<FormDrinkOrder />} />

                            {/* 🚕 TRANSPORT PUBLIC */}
                            <Route path="/transport/book" element={<TransportBookingPage />} />
                            <Route path="/experience/book" element={<ExperienceBookingPage />} />

                            <Route path="/transport/booking/:eventId" element={<TransportRequestOverview />} />
                            <Route path="/transport/booking/:eventId/:userId" element={<TransportRequestOverview />} />

                            <Route path="/transport/departure/:eventId/:userId" element={<TransportDepartureRequestPage />} />
                            <Route path="/transport/arrival/:eventId/:userId" element={<TransportArrivalRequestPage />} />
                            <Route path="/transport/my-bookings/:eventId/:userId" element={<TransportMyBookings />} />

                            {/* 🅿️ PARKING */}
                            <Route path="/parkering/:eventId/:personId" element={<ParkingValidationPage />} />
                            <Route path="/parking-pass/:token" element={<ParkingQrPassPage />} />
                            <Route path="/parking-scan/:token" element={<ParkingQrPassPage />} />

                            {/* =========================
                            🛡️ ADMIN (FULLY PROTECTED)
                            ========================= */}
                            <Route element={<PrivateRoute allowedRoles={["Admin"]} />}>
                                <Route path="/admin" element={<Admin />} />
                                <Route path="/visa" element={<VisaPage />} />
                                
                                <Route path="/admin/events/files" element={<EventFilesAdminPage />} />
                                <Route path="/events/:eventId/files" element={<EventFilesViewPage />} />
                                <Route path="/admin/transport/settings" element={<TransportAdminPageSettings />} />
                                <Route path="/admin/Experience" element={<ExperienceAdminPage />} />
                                <Route path="/TransportDashboard" element={<TransportDashboard />} />
                                <Route path="/admin/Transport/daily" element={<TransportAdminPageDaily />} />

                                <Route path="/admin/hotel" element={<HotelMenuPage />} />
                                <Route path="/admin/hotels" element={<HotelAdminPage />} />
                                <Route path="/admin/hotel-bookings" element={<HotelBookingAdminPage />} />
                                <Route path="/hotel-payment/success" element={<HotelPaymentSuccessPage />} />
                                <Route path="/hotel-payment/cancel" element={<HotelPaymentCancelPage />} />

                                <Route path="/admin/drinks/order/:eventId/:id" element={<FormDrinkOrder />} />
                                <Route path="/admin/drinks/group-allowance" element={<AdminDrinkFunctionAllowance />} />
                                <Route path="/admin/drinks/person-allowance" element={<AdminDrinkPersonAllowance />} />
                                <Route path="/admin/drinks/allowance" element={<AdminDrinkAllowance />} />
                                <Route path="/admin/event-bars" element={<EventBarsPage />} />
                                <Route path="/admin/drinks/overview" element={<AdminDrinkOverview />} />
                                
                                <Route path="/admin/drinks/assigned" element={<AdminDrinkAssignedPersons />} />
                                <Route path="/admin/drink-ticket-collections" element={<AdminDrinkTicketCollections />} />
                                <Route path="/admin/drink-ticket-print" element={<AdminDrinkTicketPrint />} />

                                <Route path="/admin/transport/overview/:eventId" element={<AdminTransportBookings />} />
                                <Route path="/admin/MeetingAdmin" element={<MeeetingAdminPage />} />
                                <Route path="/admin/TransportVIP" element={<TransportVIP />} />
                                <Route path="/admin/person-overview-access" element={<EventOverviewFeatureAccessAdminPage />} />
                                <Route path="/admin/TransportRouteDashboard" element={<TransportRouteDashboard />} />
                                <Route path="/admin/transport-routes" element={<TransportRouteAdminPage />} />
                                <Route path="/transport-route/book" element={<TransportRouteBookingPage />} />
                                <Route path="/admin/transport-route/bookings" element={<TransportRouteBookingsAdminPage />} />
                                <Route path="/transport/local/:eventId" element={<TransportLocalRequestPage />} />
                                <Route path="/admin/volunteer-groups" element={<VolunteerGroupsPage/>} />
                                <Route path="/admin/whatsapp" element={<WhatsAppAdmin />} />

                                <Route path="admin" element={<PrivateRoute allowedRoles={["Admin"]} />}>
                                    <Route path="mediaapplication" element={<MediaAdminPage />} />
                                </Route>

                            </Route>

                        </Route>

                    </Routes>
                </Router>
            </LanguageProvider>
        </MantineProvider>
    );
};

export default App;